const loginForm = document.querySelector("#main:has(.bss-fl-message) form[action='/account/login']");
if (loginForm) {
  const formData = new FormData(loginForm);
  const returnUrl = formData.get("return_url");
  window.location.href = `/account/login?checkout_url=${returnUrl}`;
}

setTimeout(() => {
  if (window.location.href.includes("checkout_url=")) {
    const registerLink = document.querySelector("#customer_login a[href^='/account/register']");
    if (registerLink) {
      registerLink.setAttribute("href", "/pages/provider-register");
    }
  }
}, 500);

function waitForObserverComplete() {
  return new Promise((resolve) => {
    BSS_B2B.observer.cartSubject.notifyObserver("CartMutate", "CartPriceMutate");
    setTimeout(resolve, 200);
  });
}

if (typeof BSS_B2B !== "undefined") {
    const loop = setInterval(() => {
        const rebuyCart = document.querySelector("#rebuy-cart");
        if (rebuyCart) {
            clearInterval(loop);

            const mutationObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.target.classList.contains("is-visible")) {
                        handleRebuyCartVisible();
                    }
                });
            });

            mutationObserver.observe(rebuyCart, {
                attributes: true,
                attributeFilter: ["class"],
            });
        }
    }, 1000);

    setTimeout(() => clearInterval(loop), 20000);

    if (window.location.pathname.includes("/products/")) {
      setTimeout(() =>{
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
        BSS_B2B?.observer?.productSubject?.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
      }, 2000)
    }
}

async function handleRebuyCartVisible() {
    const rebuyCart = document.querySelector(".rebuy-cart");
    if (!rebuyCart) return;
    
    rebuyCart.setAttribute("bss-hide-price", "");

    setTimeout(async () => {
        let cartList = BSS_B2B.shopData.cart.items;
        if (!cartList?.length) {
            cartList = await getCartItems();
            if (!cartList || cartList.length === 0) return;
        }

        const rebuyCartItems = document.querySelectorAll(".rebuy-cart__flyout-items .rebuy-cart__flyout-item");
        rebuyCartItems.forEach((rebuyCartItem, index) => {
            const item = cartList[index];
            const priceElement = rebuyCartItem.querySelector(".rebuy-cart__flyout-item-price");
            if (priceElement) {
                priceElement.setAttribute("bss-b2b-cart-item-key", item.key);
                priceElement.setAttribute("bss-b2b-item-original-price", "");
            }
        });

        // const subTotal = document.querySelector(".rebuy-cart__flyout-subtotal-amount");
        // if (subTotal && !subTotal.hasAttribute("bss-b2b-cart-total-price")) {
        //     subTotal.setAttribute("bss-b2b-cart-total-price", "");
        // }

        BSS_B2B.observer.cartSubject.notifyObserver("CartMutate", "CartPriceMutate");
        rebuyCart.removeAttribute("bss-hide-price");
    }, 3000);

    if (!document.querySelector(".checkout-btn")) {
        const checkoutBtn = document.querySelector(".rebuy-cart__checkout-button");
        if (checkoutBtn) {
            checkoutBtn.insertAdjacentHTML(
                "afterend",
                `<div class="${checkoutBtn.classList} checkout-btn">${checkoutBtn.innerText}</div>`
            );
            checkoutBtn.style.display = "none";
            document.querySelector(".checkout-btn").addEventListener("click", () => {
                window.location.href = "/checkout";
            });
        }
    }
}

async function getCartItems() {
  try {
      const res = await fetch("/cart", {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
          },
      });
      const resJson = await res.json();
      return resJson.items;
  } catch (err) {
      console.error("Failed to fetch cart items", err);
      return [];
  }
}


const checkoutUrls = ['/checkout', '/cart/checkout']
const checkoutFetchOverride = () => {
    if (!window.fetch || typeof window.fetch !== 'function') return;
    const originalFetch = window.fetch;

    window.fetch = function () {
        const response = originalFetch.apply(this, arguments);
        if (checkoutUrls.some(url => arguments[0].includes(url)) && document.querySelector(".checkout-btn")) {
            document.querySelector(".checkout-btn").click();
        }

        return response;
    };
};
